export const large = '@media (min-width: 1250px)';
export const medium = '@media (min-width: 850px) and (max-width: 1249px)';
export const small = '@media (max-width: 849px)';
